module.exports = __webpack_public_path__ + "img/logo.aeb6561f.png";